import RestrictedTab from '../RestrictedTab'
import ChannelsSection from '../ChannelsSection'

/**
 * Channels Tab — connection state and credentials only (App IA v5 · phase 2c,
 * `settings-consolidation.md` §3.6).
 *
 * Relocated out of `screens/Account.tsx`'s Integrations tab, and it keeps that screen's
 * role gate — see `RestrictedTab`. Credentials in particular: the Twilio fields below
 * this had no gate of their own on either screen.
 *
 * Shopify and the tracking script did not come with it — they are Store's; see
 * `ChannelsSection`.
 */
const ChannelsTab = () => (
  <RestrictedTab>
    <ChannelsSection />
  </RestrictedTab>
)

export default ChannelsTab
